import { hasPermission as baseHasPermission } from '@ui/lib/auth'
import { UserRole } from '@/config/roles'

export function hasPermission(role: UserRole | undefined, expectedMinRole: UserRole): boolean {
  return baseHasPermission(role, expectedMinRole)
}

export { UserRole }
